import React from "react";
import { Map, BookOpen, MapPin, Star } from "lucide-react";
import { TspCard } from "../../../components/primitives";
import { formatNumber } from "../../../utils/tspFormat";

// Icon + tone per tile follow the design (orange journeys/books, blue map
// pins, green stars). `stats` is the API summary's `this_year`.
export default function ThisYearStatsPanel({ stats }) {
  if (!stats) return null;

  const booksVal = stats.total_books ?? stats.books;
  const avgRespVal = stats.avg_response ?? stats.average_response ?? stats.average_score;

  const formatAvgResponse = (val) => {
    if (val == null) return "—";
    const num = Number(val);
    if (Number.isNaN(num)) return String(val);
    return num.toFixed(1);
  };

  const tiles = [
    { label: "Total Journeys", value: stats.total_journeys != null ? formatNumber(stats.total_journeys) : "0", icon: Map, tone: "orange" },
    { label: "Total Books", value: booksVal != null ? formatNumber(booksVal) : "0", icon: BookOpen, tone: "orange" },
    { label: "States Covered", value: stats.states_covered != null ? formatNumber(stats.states_covered) : "0", icon: MapPin, tone: "blue" },
    { label: "Avg Response", value: formatAvgResponse(avgRespVal), icon: Star, tone: "green" },
    { label: "Cities Covered", value: stats.cities_covered != null ? formatNumber(stats.cities_covered) : "0", icon: MapPin, tone: "blue" },
    { label: "Completed Journeys", value: stats.completed != null ? formatNumber(stats.completed) : "0", icon: Star, tone: "green" },
    { label: "Cancelled Journeys", value: stats.cancelled != null ? formatNumber(stats.cancelled) : "0", icon: MapPin, tone: "blue" },
    { label: "Total Teams", value: stats.total_teams != null ? formatNumber(stats.total_teams) : "0", icon: Star, tone: "green" },
  ];

  return (
    <TspCard title="This Year Stats" className="tsp-year-stats tsp-title-16">
      <div className="tsp-year-stats-grid">
        {tiles.map((tile) => (
          <div key={tile.label} className="tsp-year-stat-tile">
            <tile.icon size={16} className={`tsp-year-stat-icon tsp-icon-${tile.tone}`} />
            <div className="tsp-year-stat-value">{tile.value}</div>
            <div className="tsp-year-stat-label">{tile.label}</div>
          </div>
        ))}
      </div>
    </TspCard>
  );
}
